import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import { useFilterContext } from "../../../hooks/FilterContext";
import { Button } from "../../../components";
import { DateInput, FormSelect } from "../../../components/forms";
import { ThemedSpan } from "../../../components/utilities";
import HeadOfficeUserFormSelect from "../../headofficefeemanagement/components/HeadOfficeUserFormSelect";
import ThemedModal from "../../../components/utilities/ThemedModal";


export const AdviserLeagueTableModal = ({ handleClose, onFiltersChanged, show, ...rest }) => {

    const { defaultFilters, filter, setFilter } = useFilterContext();
    const [tempFilters, setTempFilters] = useState(filter);
    const onApplyFilters = () => {
        setFilter(original => {
            return {
                ...original,
                ...tempFilters
            }
        });
        onClose();
    };

    const onClearFilters = () => {
        setTempFilters(_ => defaultFilters);
    };

    const onFilterValueChanged = (property, value) => {
        setTempFilters(original => {
            return {
                ...original,
                [property]: value
            };
        });
    };

    const onClose = () => {
        if (handleClose && typeof (handleClose) === 'function') {
            handleClose();
        }
    };

    useEffect(() => {
        if (!_.isEqual(filter, tempFilters)) {
            setTempFilters(_ => filter);
        }
    }, [filter]);

    return <Modal size="lg" centered backdrop="static" show={show}>
        <ThemedModal.Header>
            <Modal.Title>Adviser League Table Filters</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body {...rest}>
            <AdviserLeagueTableFilters
                filter={tempFilters}
                setFilter={onFilterValueChanged}
            />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="warning" onClick={onClearFilters}>Clear Filters</Button>
            <Button variant="success" onClick={onApplyFilters}>Apply Filters</Button>
            <Button variant="light" onClick={onClose}>Cancel</Button>
        </Modal.Footer>
    </Modal>
};


const AdviserLeagueTableFilters = ({ filter, setFilter }) => {

    const {
        advisers,
        reportDate
    } = filter || {};

    return <React.Fragment>
        <div className="row mb-3">
            <div className="col d-flex align-items-end justify-content-between">
                <DateInput
                    label={"Report Date"}
                    placeholder="Report Date"
                    disableAnimations={true}
                    value={reportDate}
                    onBlur={(value, _) => setFilter('reportDate', value)}
                />
                <div className="col">
                </div>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col">
                <HeadOfficeUserFormSelect
                    label={"Advisers"}
                    isMulti={true}
                    value={advisers}
                    onChange={(values) => setFilter("advisers", values)}
                />
            </div>
        </div>
    </React.Fragment>
};

export default AdviserLeagueTableFilters;